var _g, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackToTop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#back_to_top_svg__filter0_d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 27,
    r: 21,
    fill: "#fff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.707 21.707l-.707.707.707-.707zm-8 8L29 22.414 27.586 21l-7.293 7.293 1.414 1.414zM29 22.414l7.293 7.293 1.414-1.414L30.414 21 29 22.414zm0 0L30.414 21a2 2 0 00-2.828 0L29 22.414z",
    fill: "#676A70"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29 22v16M23 17h12",
    stroke: "#676A70",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "back_to_top_svg__filter0_d",
    x: 0,
    y: 0,
    width: 58,
    height: 58,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.14902 0 0 0 0 0.164706 0 0 0 0 0.2 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
export default __webpack_public_path__ + "static/back_to_top.8add51f4.svg";
export { SvgBackToTop as ReactComponent };